import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import cx from 'classnames';
import Discount from 'shared/components/Discount/Discount';
import { createdDate } from 'shared/helpers/moment';
import { EVENTS } from 'shared/constants/gtmEvents';
import { setDataLayer } from 'shared/actions/globals';
import Row from 'shared/components/AntdComponents/Grid/Row/Row';
import Col from 'shared/components/AntdComponents/Grid/Col/Col';
import Favourite from 'desktop/components/Favourite/Favourite';
import ModalContainer from 'shared/components/ModalContainer/ModalContainer';
import LeasingOnlineBanner from 'shared/components/LeasingOnlineBanner/LeasingOnlineBanner';
import { withTranslate } from 'shared/hocs/withTranslate';

import TitleLeasingLink from './AdvertTitleLeasingLink';

// eslint-disable-next-line css-modules/no-unused-class
import s from './AdvertTitle.css';

class AdvertTitle extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    seoTitle: PropTypes.string.isRequired,
    clarifyPriceLink: PropTypes.string,
    views: PropTypes.number,
    id: PropTypes.number.isRequired,
    prices: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    advert: PropTypes.shape(),
    dateCreated: PropTypes.string,
    isSpare: PropTypes.bool,
    isNegotiablePrice: PropTypes.bool,
    leasingParams: PropTypes.shape(),
    //
    intl: intlShape.isRequired,
    setDataLayer: PropTypes.func.isRequired,
  };
  static defaultProps = {
    views: 0,
    advert: {},
    price: 0,
    dateCreated: '',
    isSpare: false,
    clarifyPriceLink: null,
    isNegotiablePrice: false,
    leasingParams: {},
  };

  state = {
    showLeasingOnlineModal: false,
  };

  toggleLeasingModal = () => {
    this.setState({ showLeasingOnlineModal: !this.state.showLeasingOnlineModal });
    this.props.setDataLayer(EVENTS.leasing.online.LinkUnderThePrice);
  };

  render() {
    const {
      id,
      views,
      title,
      seoTitle,
      dateCreated,
      prices,
      intl,
      isSpare,
      clarifyPriceLink,
      isNegotiablePrice,
      advert,
      leasingParams,
    } = this.props;

    // const { active, discount: mainDiscount, agency, sold = false } = advert;
    const { discount: mainDiscount, agency } = advert;
    const { locale } = intl;
    const date = dateCreated && createdDate(dateCreated, locale);
    const isContractPrice = !(prices.length > 0 && prices.some(p => p.value && p.value !== '0'));
    // const hideCreditForm = active === -2 || !active || sold || isSpare;

    const discount = agency && agency.id && (mainDiscount || agency.discount);

    return (
      <div className={s.root}>
        <Row>
          <h1 className={s.h1}>{seoTitle} ({id})</h1>
        </Row>
        <Row>
          <Col span={16}>
            <h2 className={s.title}>{title}</h2>
          </Col>
          <Col span={8}>
            <Row type="flex" justify="end">
              <React.Fragment>
                {!isSpare && isNegotiablePrice && (
                  <div className={s.contractPrice}>{intl.formatMessage({ id: 'договорная' })}</div>
                )}
                {!isSpare && !isNegotiablePrice && (
                  <div className={s.price}>
                    {clarifyPriceLink ? (
                      <a
                        className={s.clarifyPrice}
                        href={clarifyPriceLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FormattedMessage id="Уточнить цену у дилера" />
                      </a>
                    ) : (
                      prices.length > 0 && (
                        <div className={s.priceList}>
                          {prices.map(({ currency, value }) => (
                            <div className={s.priceItem} key={value + currency}>
                              {value}&nbsp;
                              <small>{currency}</small>
                            </div>
                          ))}
                          {discount && <Discount discount={discount} />}
                        </div>
                      )
                    )}
                  </div>
                )}
                {isSpare && (
                  <div className={(s.price, { [s.contractPrice]: isContractPrice })}>
                    {prices.length > 0 && prices.some(p => p.value && p.value !== '0') ? (
                      <div className={s.priceList}>
                        {prices.map(({ currency, value }) => (
                          <div className={s.priceItem} key={value + currency}>
                            {value}&nbsp;
                            <small>{currency}</small>
                          </div>
                        ))}
                      </div>
                    ) : (
                      intl.formatMessage({ id: 'договорная' })
                    )}
                  </div>
                )}
                {leasingParams && leasingParams.monthlyPayment && (
                  <TitleLeasingLink
                    monthlyPayment={leasingParams.monthlyPayment}
                    onClick={this.toggleLeasingModal}
                  />
                )}
                {this.state.showLeasingOnlineModal && (
                  <ModalContainer
                    modalCN={s.modal}
                    onClose={this.toggleLeasingModal}
                    isOpen={this.state.showLeasingOnlineModal}
                  >
                    <div className={s.rootModal}>
                      <div className={s.rootModalLeasing}>
                        <LeasingOnlineBanner
                          advert={advert}
                          modalMode
                          leasingParams={leasingParams}
                          toggleLeasingModal={this.toggleLeasingModal}
                        />
                        <i
                          className={cx({
                            'fa fa-times': true,
                            [s.closeBtnIcon]: true,
                          })}
                          onClick={this.toggleLeasingModal}
                        />
                      </div>
                    </div>
                  </ModalContainer>
                )}
              </React.Fragment>
            </Row>
          </Col>
        </Row>
        <Row className={s.yearSection}>
          <Col span={16}>
            <div>
              <span className={s.id}>№ {id}</span>
              <span className={s.date}>{date}</span>
              <span className={s.views}>
                <i className="fa fa-eye" />
                {views || 0}
              </span>
              <div className={s.favoriteContainer}>
                <Favourite id={id} imgWidth={18} isCompact />
              </div>
            </div>
          </Col>
          <Col span={8} className={s.blockRightFlex}>
            {/* <LeasingForm advert={advert} /> */}
            {/* !!hideCreditForm || <CreditForm advert={advert} /> */}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapDispatchToProps = { setDataLayer };

export default withStyles(s)(
  injectIntl(withTranslate(connect(null, mapDispatchToProps)(AdvertTitle)))
);



// WEBPACK FOOTER //
// ./src/desktop/components/AdvertTitle/AdvertTitle.js